<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Rapor Kodu</label>
            <input class="form-control" v-model="value.Code" placeholder="Rapor Kodu"/>
        </div>
    </div>
</template>

<script>
export default { 
    props:{
        value:Object
    }
}
</script>